export default __webpack_public_path__ + "static/media/institucional2.d899dfd2.svg";